import { useDispatch, useSelector } from "react-redux";
import { downloadTradeByBrokersReport } from "../thunks/downloadReport";
import React from "react";
import { StoreType } from "../../../../../core/store/reducers";
import { FetchStateType } from "../../../../models";

export const useTradeByBrokersReportDownloader = () => {
  const fetchState = useSelector<StoreType, FetchStateType>(
    (s) => s.data.reports.exchbusiness.tradeByBrokers.downloadReportFetchState
  );
  const dispatch = useDispatch();
  const download = React.useCallback(
    () => dispatch(downloadTradeByBrokersReport()),
    [dispatch]
  );

  return [download, fetchState] as [typeof download, typeof fetchState];
};
